import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const base = (rid) => `${API_URL}/users/restaurant/${rid}`;

// ---- Tax Labels -----------------------------------------------------------

export const listTaxLabels = async (restaurantId) => {
  const { data } = await axios.get(`${base(restaurantId)}/tax-labels/`);
  return data?.results || [];
};

export const createTaxLabel = async (restaurantId, payload) => {
  const { data } = await axios.post(`${base(restaurantId)}/tax-labels/`, payload);
  return data?.data;
};

export const updateTaxLabel = async (restaurantId, labelId, payload) => {
  const { data } = await axios.patch(`${base(restaurantId)}/tax-labels/${labelId}/`, payload);
  return data?.data;
};

export const deleteTaxLabel = async (restaurantId, labelId) => {
  const { data } = await axios.delete(`${base(restaurantId)}/tax-labels/${labelId}/`);
  return data;
};

// ---- Tax Rates (history per label) ----------------------------------------

export const listTaxRates = async (restaurantId, labelId) => {
  const { data } = await axios.get(`${base(restaurantId)}/tax-labels/${labelId}/rates/`);
  return data?.results || [];
};

export const createTaxRate = async (restaurantId, labelId, payload) => {
  const { data } = await axios.post(`${base(restaurantId)}/tax-labels/${labelId}/rates/`, payload);
  return data?.data;
};

export const deleteTaxRate = async (restaurantId, labelId, rateId) => {
  const { data } = await axios.delete(`${base(restaurantId)}/tax-labels/${labelId}/rates/${rateId}/`);
  return data;
};

// ---- Tax Groups -----------------------------------------------------------

export const listTaxGroups = async (restaurantId) => {
  const { data } = await axios.get(`${base(restaurantId)}/tax-groups/`);
  return data?.results || [];
};

export const createTaxGroup = async (restaurantId, payload) => {
  const { data } = await axios.post(`${base(restaurantId)}/tax-groups/`, payload);
  return data?.data;
};

export const updateTaxGroup = async (restaurantId, groupId, payload) => {
  const { data } = await axios.patch(`${base(restaurantId)}/tax-groups/${groupId}/`, payload);
  return data?.data;
};

export const deleteTaxGroup = async (restaurantId, groupId) => {
  const { data } = await axios.delete(`${base(restaurantId)}/tax-groups/${groupId}/`);
  return data;
};

// ---- Applicable taxes (what bills actually charge) --------------------------

export const listApplicableTaxes = async (restaurantId) => {
  const { data } = await axios.get(`${base(restaurantId)}/taxes/applicable/`);
  return data?.results || [];
};

// ---- Tax Migration (bulk-swap a rate across items) ---------------------------

export const listTaxMigrations = async (restaurantId) => {
  const { data } = await axios.get(`${base(restaurantId)}/tax-migrations/`);
  return data?.results || [];
};

export const createTaxMigration = async (restaurantId, payload) => {
  const { data } = await axios.post(`${base(restaurantId)}/tax-migrations/`, payload);
  return data?.data;
};
